import React,  {Component, useState, useEffect} from 'react';
import { decorate, observable, action, isObservableObject } from 'mobx';
import { observer, inject } from 'mobx-react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from "underscore";
import moment from "moment";
import ReactDom from 'react-dom';
import { TermsAndPrivacy } from '../../../utils/termsAndPrivacy';


import {
  Form,
  FormGroup,
  FormTextarea,
  FormCheckbox,
  FormSelect,
  Tooltip,
  Modal,
  ModalBody,
  ModalHeader,
  InputGroup,
  InputGroupAddon,
  FormInput,
  ButtonGroup,
  Button,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem, Col, Row
} from "shards-react";
import {reactLocalStorage as Storage} from "reactjs-localstorage";

import './inAppOrder.scss';

import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';

//inport images
import bannerEvent from "../../../images/bg_event.png";
import noImg from "../../../images/img/no_img.jpg";
import history from "../../../utils/history";
import {Redirect} from "react-router-dom";

const PopupDom = ({ children }) => {
  const el = document.getElementById('popupDom');
  return ReactDom.createPortal(children, el);
};


let planPd = {
  m1000: {val:'m1000', name:"m-1000", label: "1,000", orgPrice: 12000, price: 12000, count: 1000, addCount:0 },
  m2000: {val:'m2000', name:"m-2000", label: "2,000", orgPrice: 24000, price: 24000, count: 2000, addCount:0 },
  m5000: {val:'m5000', name:"m-5000", label: "5,000", orgPrice: 63000, price: 60000, count: 5000, addCount:250 },
  m10000: {val:'m10000', name:"m-10000", label: "10,000", orgPrice: 132000, price: 120000, count: 10000, addCount:1000 },
  m20000: {val:'m20000', name:"m-20000", label: "20,000", orgPrice: 276000, price: 240000, count: 20000, addCount:3000 },
  m50000: {val:'m50000', name:"m-50000", label: "50,000", orgPrice: 720000, price: 600000, count: 50000, addCount:10000 },
}

@inject(({ teamUser }) => ({ authCheck: teamUser.authCheck, isLogin: teamUser.isLogin, me:teamUser.me,  updateInAppOrder:teamUser.updateInAppOrder, updateMsgOrder: teamUser.updateMsgOrder, checkOrder:teamUser.checkOrder, checkOrderShop: teamUser.checkOrderShop, freeEventApply: teamUser.freeEventApply }))
@inject(({ company }) => ({ getSalesReport: company.getSalesReport, getApplyShop:company.getApplyShop }))
@inject(({ common }) => ({ getDoc: common.getDoc }))

@observer
class MsgOrder extends Component {

  //http://localhost:3000/cafeMsgOrderReturnUrl?order_id=cafe24-20250514-447465981&result=success
  //http://localhost:3000/cafeMsgOrderReturnUrl?order_id=cafe24-20250510-447458880&result=success

  //http://localhost:3000/cafeMsgOrderReturnUrl?order_id=cafe24-20250318-447327123&result=failss
  //https://orvad.owphew.co.kr/cafeMsgOrderReturnUrl?order_id=cafe24-20250318-447327123&result=success

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);
  //page
  @observable planPd = planPd;
  @observable redirectInfo = {
    is: false,
    pathname: '/orderEnd'
  }
  @observable orderInfo = {
    serviceAgree: false,
    privateAgree: false,
  };
  @observable noRefundAgg = false;


  constructor(props) {
    super(props);
    this.init()
  }


  @action
  init = async (key) => {

    if(this.props.isLogin) {
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.teamUser.email = this.teamUser.email ? this.teamUser.email : this.teamUser.emailId;
      this.store = this.props.me.store ? this.props.me.store : {};

    }
  };

  onSelOrderItem = async (key) => {
    this.orderInfo = this.planPd[key];
  }

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
    }
  };

  onSubmit = async (event) => {
    let _this = this;
    event.preventDefault();
    if(!this.orderInfo.val) {
      alert('상품을 선택해 주세요.');
      return false;
    }
    else if(!this.orderInfo.serviceAgree) {
      alert('서비스 이용약관을 동의해 주세요.');
      return false;
    }
    else if(!this.orderInfo.privateAgree) {
      alert('개인정보 이용약관을 동의해 주세요.');
      return false;
    }
    else if(!this.noRefundAgg) {
      alert('환불 정책에 동의해 주세요.');
      return false;
    }
    else {

      console.log(this.orderInfo);
      // let cafe24Params = {
      //   access_token: store.cafe24Token,
      //   order_name: args.orderName,
      //   order_amount: args.orderAmount,
      //   return_url: defaultReturnUrl + "/cafeInAppOrderReturnUrl",
      //   automatic_payment: args.automaticPayment
      // }

      let params = {
        store_id: this.store._id,
        teamUser_id: this.teamUser._id,
        orderName: "알림톡 - " + this.orderInfo.name,
        plan: this.orderInfo.val,
        count: this.orderInfo.count,
        addCount: this.orderInfo.addCount,
        orderAmount: this.orderInfo.price,
        orderSaleAmount: Math.floor(this.orderInfo.price * 1.1),
        orderOrgAmount: this.orderInfo.orgPrice,
        serviceAgree: this.orderInfo.serviceAgree,
        privateAgree: this.orderInfo.privateAgree,
        automaticPayment: 'F'
      }


      this.props.updateMsgOrder(params, function(res) {

        if(res.errors && res.errors.length > 0) {
          if(res.errors[0].message == 'fail password') {

          }
          else {
            alert(res.errors[0].message);
          }
        }
        else {
          let name = 'review-widget';
          let specs = 'menubar=no,status=no,toolbar=no';
          let url = res.data.confirmation_url;
          let orderWindow = window.open(url, name, specs);

          let timeAfter = 0;
          let iVOrderCheck = setInterval(function() {
            timeAfter = timeAfter+2;
            let isMsgOrderCp = Storage.get('isMsgOrderCp');
            if(isMsgOrderCp == 'end' || timeAfter > 600) {
              clearInterval(iVOrderCheck);
              Storage.remove('isMsgOrderCp');
              _this.props.history.push('/msgOrderList');
            }
          }, 2000);


          //cafeInAppOrderReturnUrl?order_id=cafe24-20230913-446425016&result=fail
        }

      });



    }



  };


  render() {
    let _this = this;


    return (
        <>
        {this.redirectInfo.is ? (
              <Redirect to={{pathname: this.redirectInfo.pathname}} />
          ) : (
            <div className="main-content ">
              <PageTitle/>
              {(this.isLogin && this.teamUser.emailId) ? (
                  <>
                    <div className="section-box basic-info-table">
                      <div className="section-tit mt-4">
                        <h3>상품 선택하기</h3>
                        <div className="table-sub-tit">
                          <span>플랜은 주문 수 기준으로 책정됩니다.</span>
                        </div>
                      </div>

                      <div className="order-box">
                        <div className="section-cont">

                          <div className="plan">
                            <div className="plan-section alim-plan-section">
                              {/*<div className="plan-item-tit">월구독 플랜</div>*/}

                              <div className="plan-section-wrap">

                                {this.planPd ? Object.keys(this.planPd).map((key, i) => (
                                    <div key={i} className={"plan-item" + (this.orderInfo && this.orderInfo.val  === key ? " selected": "")}
                                         onClick={event => this.onSelOrderItem(key)}>
                                      <div className="plan-selected">선택됨</div>
                                      <div className="plan-item-top">
                                        <div className="plan-tag"><span className="plan-tag-txt">{this.planPd[key].name}</span></div>
                                        <div className="plan-cost"><span className="plan-cost-val">{this.planPd[key].label} 건</span>+ {this.planPd[key].addCount}건</div>
                                        {/*<div className="plan-cost-sub">(월 <span className="plan-cost-val">16,450</span>원에 이용)</div>*/}
                                      </div>
                                      <div className="plan-item-content">
                                        <ul>
                                          {/*<li className="order-list">*/}
                                          {/*  <div className="order-tit">*/}
                                          {/*    <span>보너스</span>*/}
                                          {/*  </div>*/}
                                          {/*  <div className="order-cont">*/}
                                          {/*    <span>+ {this.planPd[key].addCount}건</span>*/}
                                          {/*  </div>*/}
                                          {/*</li>*/}
                                          <li className="order-list">
                                            <div className="order-tit">
                                              <span>총 발송건수</span>
                                            </div>
                                            <div className="order-cont">
                                              <span>{this.planPd[key].count + this.planPd[key].addCount}건</span>
                                            </div>
                                          </li>
                                          <li className="order-list">
                                            <div className="order-tit">
                                              <span>단가</span>
                                            </div>
                                            <div className="order-cont">
                                              <span>{(this.planPd[key].price / (this.planPd[key].count + this.planPd[key].addCount)).toFixed(1)}원</span>
                                            </div>
                                          </li>

                                          <li className="order-list">
                                            <div className="order-tit">
                                              <span>상품 금액</span>
                                            </div>
                                            <div className="order-cont">
                                              <span>{this.planPd[key].orgPrice.toLocaleString()}</span>원
                                            </div>
                                          </li>
                                          <li className="order-list">
                                            <div className="order-tit">
                                              <span>할인 금액</span>
                                            </div>
                                            <div className="order-cont">
                                              <span>{this.planPd[key].price.toLocaleString()}</span>원
                                            </div>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="plan-item-bottom">
                                        <button className="btn-plan-select" type="button">선택하기</button>
                                      </div>
                                    </div>
                                )) : null}
                              </div>

                              <div className="plan-desc">
                                <ul>
                                  <li>- 표기된 금액은 모두 부가세 별도 금액입니다.</li>
                                  <li>- 충전하신 알림톡은 5년 동안 사용하실 수 있으며, 기한 내 남은 알림톡은 환불 가능합니다.</li>
                                  <li>- 알림톡 환불에 대한 처리는 온똑똑 이용약관 제 26조에 따릅니다.</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="order-box">
                      <div className="section-box basic-info-box">
                        <div className="section-tit">
                          <h3>약관 동의</h3>
                        </div>
                        <div className="section-cont">
                          <table>
                            <colgroup>
                              <col width=""/>
                              <col width="80%"/>
                            </colgroup>
                            <tbody>
                            <tr>
                              <th>서비스 이용약관</th>
                              <td>
                                <div className={"terms-privacy"}
                                     dangerouslySetInnerHTML={{__html: TermsAndPrivacy.termsOfService}}></div>
                                <FormGroup className="float-right serviceAgreeCheck">
                                  <FormCheckbox name="serviceAgree" toggle
                                                checked={this.orderInfo.serviceAgree || false}
                                                onChange={event => this.onChangeChecked(event, this.orderInfo, ['serviceAgree'])}>
                                    유료서비스 이용약관 동의
                                  </FormCheckbox>
                                </FormGroup>
                              </td>
                            </tr>
                            <tr>
                              <th>개인정보 이용약관</th>
                              <td>
                                <div className={"terms-privacy"}
                                     dangerouslySetInnerHTML={{__html: TermsAndPrivacy.privacyPolicy}}></div>

                                <FormGroup className="float-right serviceAgreeCheck">
                                  <FormCheckbox name="privateAgree" toggle
                                                checked={this.orderInfo.privateAgree || false}
                                                onChange={event => this.onChangeChecked(event, this.orderInfo, ['privateAgree'])}>
                                    개인정보 이용약관 동의
                                  </FormCheckbox>
                                </FormGroup>
                              </td>
                            </tr>
                            <tr>
                              <th>이벤트 상품 환불 불가</th>
                              <td>
                                <div>
                                  <strong>제 26 조 (알림톡 상품 환불 정책)</strong><br />
                                  ① 사용 내역이 없는 포인트는 전액 결제 취소가 가능합니다.<br/>
                                  ② 결제 취소가 불가한 포인트는 기획재정부에서 고시한 『소비자분쟁해결기준』에 따라 위약금(최종 결제 요금의 10%) 을 공제 후 환불합니다. 단, 남은
                                  금액이 공제금액보다 작은 경우에는 환불할 수 없습니다.<br/>
                                  ③ 환불 시 받은 보너스 건수는 100% 제외 후 환불합니다.<br/>
                                  ④ 환불 시 카드결제가 취소가 어려운 상황에서는 환불에 대한 세금계산서를 제출하여 환불을 요청할 수 있습니다.<br/>
                                  ⑤ 다음과 같은 경우 포인트는 환불되지 않습니다.<br/>
                                  가.포인트 유효기간 경과한 경우(유효기간 5년)<br/>
                                  나.원이 서비스 자진 탈퇴 시 잔여 포인트 환불을 포기한 경우<br/>
                                </div>
                                <FormGroup className="float-right serviceAgreeCheck">
                                  <FormCheckbox name="noRefundAgg" toggle
                                                checked={this.noRefundAgg || false}
                                                onChange={event => this.onChangeChecked(event, this, ['noRefundAgg'])}>
                                    알림톡 상품 환불 정책 동의
                                  </FormCheckbox>
                                </FormGroup>
                              </td>
                            </tr>

                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="btn-save">
                        {this.orderInfo && this.orderInfo.val ? (
                            <input type="button" onClick={event => this.onSubmit(event)} value={"주문하기"} className="save-button"/>
                            ) : (
                            <input type="button" value={"주문하기"} disabled={true} className="save-button disabled"/>
                        )}
                      </div>

                    </div>

                  </>
              ) : <p className='empty'><a href='/signin'>로그인하세요.</a></p>}
            </div>
        )}
        </>
    )
  }
}

export default MsgOrder;
